import React, { useMemo, useState } from "react";
import api from "../../services/axios";
import { postLoginTarget } from "../../utils/authSession";

export default function SetPassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState("");

  const canSubmit = useMemo(() => {
    return (
      password.trim().length >= 8 &&
      confirm.trim().length >= 8 &&
      password === confirm &&
      !isSubmitting
    );
  }, [password, confirm, isSubmitting]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const pw = password.trim();
    const cf = confirm.trim();

    if (!pw || !cf) {
      setError("Please enter password and confirm password.");
      return;
    }
    if (pw.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (pw !== cf) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    try {
      await api.post("/auth/local/set-my-password", { password: pw });
      setSuccess("Password updated.");
      setPassword("");
      setConfirm("");
      setTimeout(async () => window.location.replace(await postLoginTarget()), 600);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to set password.";
      setError(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 520, margin: "0 auto", padding: "24px 16px" }}>
      <h2 style={{ marginBottom: 6 }}>Set Password</h2>
      <div style={{ color: "#6c757d", marginBottom: 18 }}>
        Set a password for your account. Sign in to the app is via Feuji SSO.
      </div>

      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
            New Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            placeholder="Minimum 8 characters"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid #dee2e6",
            }}
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
            Confirm Password
          </label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            placeholder="Re-enter password"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid #dee2e6",
            }}
          />
        </div>

        {error ? (
          <div style={{ color: "#dc3545", marginBottom: 10 }}>{error}</div>
        ) : null}
        {success ? (
          <div style={{ color: "#198754", marginBottom: 10 }}>{success}</div>
        ) : null}

        <button
          type="submit"
          disabled={!canSubmit}
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: 10,
            border: "none",
            background: canSubmit ? "#0d6efd" : "#6c757d",
            color: "#fff",
            fontWeight: 700,
          }}
        >
          {isSubmitting ? "Saving..." : "Save Password"}
        </button>
      </form>
    </div>
  );
}

